import React from "react";

export const DeactivatedAccountPage = () => {
  return (
    <div className="bg-[#fafafa] max-w-[100%] w-full px-7 py-5">
      <div className="flex justify-between items-center">
        <div className="text-2xl font-bold">
          Your account has been deactivated
        </div>
      </div>

      <div className="border bg-white rounded-md mt-4">
        <div className="block lg:flex justify-between p-2 items-center mb-5 lg:mb-0">
          Your account has been deactivated by your clinic admin. Please reach out to your HR to find out more
        </div>
      </div>
    </div>
  );
};
